/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Link, useNavigate } from "react-router-dom";

import calanderIc from "../../assets/images/calendar.svg";
import "./style.css";
// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import { toast } from "react-toastify";
import axios from "axios";
import jsPDF from "jspdf";
import { useTable } from "react-table";
import moment from "moment/moment";
import MDModal from "components/MDModal";

function AddPassport() {
  const navigate = useNavigate();
  const [passport, setPassport] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [directorsGovernmentID, setDirectorsGovernmentID] = useState("");
  const token = localStorage.getItem("token");
  console.log(passport, directorsGovernmentID, dateOfBirth, 4555);
  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        "https://companyprocessuk.com/api/add-passport",
        {
          passport,
          directorsGovernmentID,
          dateOfBirth,
        },
        {
          headers: {
            Auth: token,
          },
        }
      );
      toast.success(response?.data?.message);
      navigate("/passport-list");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <div>
        <div className="container">
          <div className="pass-wrapper">
            <div className="title-sec">
              <p>Add PassPort</p>
            </div>
            <div className="passport-form-wrapper">
              <div className="form-wrapper">
                <div className="input-wrapper">
                  <input
                    type="text"
                    className="cus-input"
                    placeholder="Company Number"
                    value={passport}
                    onChange={(e) => {
                      setPassport(e.target.value);
                    }}
                    autoComplete="off"
                  />
                </div>

                <div className="input-wrapper">
                  <input
                    type="text"
                    className="cus-input"
                    placeholder="Government ID"
                    value={directorsGovernmentID}
                    onChange={(e) => {
                      setDirectorsGovernmentID(e.target.value);
                    }}
                    autoComplete="off"
                  />
                </div>

                <>
                  <div className="datepicker-main">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          className="new-datepicker-input"
                          label="Date of Birth"
                          fullWidth
                          views={["year", "month", "day"]}
                          onChange={(value) => {
                            const formatedDate = moment(value.$d).format("YYYY-MM-DD");
                            setDateOfBirth(formatedDate);
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                </>

                <div className="submit-btn-sec">
                  <button
                    type="button"
                    className="check-btn submit-btn"
                    color="info"
                    disabled={!(dateOfBirth && passport && directorsGovernmentID)}
                    onClick={handleSubmit}
                    style={{ cursor: "pointer" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddPassport;
